import { CompassCardUI } from '@scale/compass-ui/types';
import { PodGroup } from '@scale/shared-types';
import {
  CommunicationsCenterSendCardShared,
  type CommunicationsCenterSendContext,
  type CommunicationsCenterSendContextSchemaType,
  COMMUNICATIONS_CENTER_SEND,
} from '@scale/genai-compass-shared/cards/communications_center_send';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons';
import CommunicationsCenterCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/CommunicationCenterCard/CommunicationsCenterCardComponent';

const defaultContext: CommunicationsCenterSendContext = {
  cardType: COMMUNICATIONS_CENTER_SEND,
  templateId: '',
  communicationName: '',
  templateVariableColumnIds: [],
  podGroup: PodGroup.None,
};

export const CommunicationsCenterSendCardInfo: CompassCardUI<CommunicationsCenterSendContextSchemaType> =
  {
    ...CommunicationsCenterSendCardShared,
    title: 'Send Communication',
    icon: 'envelope',
    toolTip: 'Send communications to users from Growth Center',
    defaultContext,
    showOutput: true,
    button: {
      icon: faPaperPlane,
    },
    legacyComponent: CommunicationsCenterCardComponent,
  };
